var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationHandPlate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 60.884a.884.884 0 01-.625-1.509l13.938-13.938 5.895-8.842 2.964-7.906a.886.886 0 011.656.622l-3.093 8.179-6.11 9.135-14 14a.879.879 0 01-.625.259M24.001 51a.999.999 0 01-.987-1.164l1.091-6.283L27 37.764v-4.641l-.97-3.881a1 1 0 111.94-.484L29 33v5.236l-3.039 6.077-.975 5.851a1 1 0 01-.985.836M38.884 42.06l-4.787-2.393-1.083-6.503-.984-3.922a1 1 0 111.94-.484l1 4 .932 5.575 3.214 1.607 3.43-.857 4.681-3.745 3.905-6.834a1 1 0 111.736.992l-4.095 7.166-5.319 4.255-4.57 1.143M9 64a.999.999 0 01-.707-1.707l7-7a.999.999 0 111.414 1.414l-7 7A.997.997 0 019 64M25 72a.999.999 0 01-.707-1.707l3-3a.999.999 0 111.414 1.414l-3 3A.997.997 0 0125 72",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.414 55L29 67.586 34.586 62 22 49.414 16.414 55zM29 70a.997.997 0 01-.707-.293l-14-14a.999.999 0 010-1.414l7-7a.999.999 0 011.414 0l14 14a.999.999 0 010 1.414l-7 7A.997.997 0 0129 70z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 63a.997.997 0 01-.707-.293l-2-2a.999.999 0 111.414-1.414l2 2A.999.999 0 0130 63M39 42a.999.999 0 01-.707-1.707l4.864-4.864 2.924-6.823a1 1 0 011.838.788l-3.076 7.177-5.136 5.136A.997.997 0 0139 42",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M12 26h60v-2H12z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.351 30H20.65l-5.274-4.219a1 1 0 011.25-1.562L21.351 28H62.65l4.726-3.781a1 1 0 111.25 1.562L63.351 30M23.293 19.707l-3-3 1.414-1.414 3 3-1.414 1.414M32.105 14.447l-2-4 1.79-.894 2 4-1.79.894M60.707 19.707l-1.414-1.414 3-3 1.414 1.414-3 3M51.895 14.447l-1.79-.894 2-4 1.79.894-2 4M41 12h2V8h-2z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationHandPlate;